/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as SetNewPasswordImport } from './routes/set-new-password'
import { Route as PasswordResetImport } from './routes/password-reset_'
import { Route as LogoutImport } from './routes/logout'
import { Route as LoginImport } from './routes/login'
import { Route as AppImport } from './routes/_app'
import { Route as IndexImport } from './routes/index'
import { Route as LimitedQuotationAnonymousQuotationIdImport } from './routes/limited-quotation.$anonymousQuotationId'
import { Route as AppVesselsImport } from './routes/_app.vessels'
import { Route as AppUsersImport } from './routes/_app.users'
import { Route as AppSupplierGroupsImport } from './routes/_app.supplier-groups'
import { Route as AppSearchImport } from './routes/_app.search'
import { Route as AppPortsImport } from './routes/_app.ports'
import { Route as AppIntegrationsImport } from './routes/_app.integrations'
import { Route as AppFuelImport } from './routes/_app.fuel'
import { Route as AppCustomerGroupsImport } from './routes/_app.customer-groups'
import { Route as AppAssignmentsImport } from './routes/_app.assignments'
import { Route as AppLubesImport } from './routes/_app._lubes'
import { Route as OnboardUserIdTokenImport } from './routes/onboard.$userId.$token'
import { Route as OfferOfferIdApprovalRequestImport } from './routes/offer.$offerId.approval-request'
import { Route as AppSupplierGroupIdImport } from './routes/_app.supplier-group.$id'
import { Route as AppFuelVesselsImport } from './routes/_app.fuel.vessels'
import { Route as AppFuelStatisticsImport } from './routes/_app.fuel.statistics'
import { Route as AppFuelOrdersImport } from './routes/_app.fuel.orders'
import { Route as AppFuelOffersImport } from './routes/_app.fuel.offers'
import { Route as AppFuelKeyPortsImport } from './routes/_app.fuel.key-ports'
import { Route as AppFuelGlobalPricesImport } from './routes/_app.fuel.global-prices'
import { Route as AppFuelDashboardImport } from './routes/_app.fuel.dashboard'
import { Route as AppFuelCreateImport } from './routes/_app.fuel.create'
import { Route as AppFuelContractsImport } from './routes/_app.fuel.contracts'
import { Route as AppFuelAssignmentsImport } from './routes/_app.fuel.assignments'
import { Route as AppCustomerGroupIdImport } from './routes/_app.customer-group.$id'
import { Route as AppLubesSuppliersImport } from './routes/_app._lubes.suppliers'
import { Route as AppLubesStatisticsImport } from './routes/_app._lubes.statistics'
import { Route as AppLubesProductsImport } from './routes/_app._lubes.products'
import { Route as AppLubesOrdersImport } from './routes/_app._lubes.orders'
import { Route as AppLubesOffersImport } from './routes/_app._lubes.offers'
import { Route as AppLubesKeyPortsImport } from './routes/_app._lubes.key-ports'
import { Route as AppLubesDemandImport } from './routes/_app._lubes.demand'
import { Route as AppLubesDashboardImport } from './routes/_app._lubes.dashboard'
import { Route as AppLubesCustomersImport } from './routes/_app._lubes.customers'
import { Route as AppLubesCompareImport } from './routes/_app._lubes.compare'
import { Route as AppFuelAgentsIndexImport } from './routes/_app.fuel.agents.index'
import { Route as AppLubesAgentsIndexImport } from './routes/_app._lubes.agents.index'
import { Route as AppUserDetailIdImport } from './routes/_app.user.detail.$id'
import { Route as AppSupplierDetailIdImport } from './routes/_app.supplier.detail.$id'
import { Route as AppPortDetailIdImport } from './routes/_app.port.detail.$id'
import { Route as AppFuelVesselIdImport } from './routes/_app.fuel.vessel.$id'
import { Route as AppFuelPlanningDemandImport } from './routes/_app.fuel.planning.demand'
import { Route as AppFuelPlanningBunkerPlanImport } from './routes/_app.fuel.planning.bunker-plan'
import { Route as AppFuelOrderIdImport } from './routes/_app.fuel.order.$id'
import { Route as AppFuelOfferIdImport } from './routes/_app.fuel.offer.$id'
import { Route as AppFuelAgentsIdImport } from './routes/_app.fuel.agents.$id'
import { Route as AppCustomerDetailIdImport } from './routes/_app.customer.detail.$id'
import { Route as AppLubesVesselIdImport } from './routes/_app._lubes.vessel.$id'
import { Route as AppLubesOrdersNewImport } from './routes/_app._lubes.orders_.new'
import { Route as AppLubesOrderIdImport } from './routes/_app._lubes.order.$id'
import { Route as AppLubesOfferIdImport } from './routes/_app._lubes.offer.$id'
import { Route as AppLubesAgentsIdImport } from './routes/_app._lubes.agents.$id'
import { Route as AppFuelOrderIdEditImport } from './routes/_app.fuel.order.$id_.edit'
import { Route as AppFuelOfferIdQuoteImport } from './routes/_app.fuel.offer.$id_.quote'
import { Route as AppFuelOfferIdEditImport } from './routes/_app.fuel.offer.$id_.edit'
import { Route as AppLubesOrdersDraftIdImport } from './routes/_app._lubes.orders_.draft.$id'
import { Route as AppLubesOrderEditIdImport } from './routes/_app._lubes.order_.edit.$id'
import { Route as AppLubesOfferIdQuoteImport } from './routes/_app._lubes.offer.$id_.quote'
import { Route as AppLubesOfferIdEditImport } from './routes/_app._lubes.offer.$id_.edit'
import { Route as AppFuelPlanningSolutionsVesselIdCaseNumberSolutionNumberImport } from './routes/_app.fuel.planning.solutions.$vesselId.$caseNumber.$solutionNumber'

// Create/Update Routes

const SetNewPasswordRoute = SetNewPasswordImport.update({
  id: '/set-new-password',
  path: '/set-new-password',
  getParentRoute: () => rootRoute,
} as any)

const PasswordResetRoute = PasswordResetImport.update({
  id: '/password-reset_',
  path: '/password-reset',
  getParentRoute: () => rootRoute,
} as any)

const LogoutRoute = LogoutImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const AppRoute = AppImport.update({
  id: '/_app',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const LimitedQuotationAnonymousQuotationIdRoute =
  LimitedQuotationAnonymousQuotationIdImport.update({
    id: '/limited-quotation/$anonymousQuotationId',
    path: '/limited-quotation/$anonymousQuotationId',
    getParentRoute: () => rootRoute,
  } as any)

const AppVesselsRoute = AppVesselsImport.update({
  id: '/vessels',
  path: '/vessels',
  getParentRoute: () => AppRoute,
} as any)

const AppUsersRoute = AppUsersImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppRoute,
} as any)

const AppSupplierGroupsRoute = AppSupplierGroupsImport.update({
  id: '/supplier-groups',
  path: '/supplier-groups',
  getParentRoute: () => AppRoute,
} as any)

const AppSearchRoute = AppSearchImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AppRoute,
} as any)

const AppPortsRoute = AppPortsImport.update({
  id: '/ports',
  path: '/ports',
  getParentRoute: () => AppRoute,
} as any)

const AppIntegrationsRoute = AppIntegrationsImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => AppRoute,
} as any)

const AppFuelRoute = AppFuelImport.update({
  id: '/fuel',
  path: '/fuel',
  getParentRoute: () => AppRoute,
} as any)

const AppCustomerGroupsRoute = AppCustomerGroupsImport.update({
  id: '/customer-groups',
  path: '/customer-groups',
  getParentRoute: () => AppRoute,
} as any)

const AppAssignmentsRoute = AppAssignmentsImport.update({
  id: '/assignments',
  path: '/assignments',
  getParentRoute: () => AppRoute,
} as any)

const AppLubesRoute = AppLubesImport.update({
  id: '/_lubes',
  getParentRoute: () => AppRoute,
} as any)

const OnboardUserIdTokenRoute = OnboardUserIdTokenImport.update({
  id: '/onboard/$userId/$token',
  path: '/onboard/$userId/$token',
  getParentRoute: () => rootRoute,
} as any)

const OfferOfferIdApprovalRequestRoute =
  OfferOfferIdApprovalRequestImport.update({
    id: '/offer/$offerId/approval-request',
    path: '/offer/$offerId/approval-request',
    getParentRoute: () => rootRoute,
  } as any)

const AppSupplierGroupIdRoute = AppSupplierGroupIdImport.update({
  id: '/supplier-group/$id',
  path: '/supplier-group/$id',
  getParentRoute: () => AppRoute,
} as any)

const AppFuelVesselsRoute = AppFuelVesselsImport.update({
  id: '/vessels',
  path: '/vessels',
  getParentRoute: () => AppFuelRoute,
} as any)

const AppFuelStatisticsRoute = AppFuelStatisticsImport.update({
  id: '/statistics',
  path: '/statistics',
  getParentRoute: () => AppFuelRoute,
} as any)

const AppFuelOrdersRoute = AppFuelOrdersImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AppFuelRoute,
} as any)

const AppFuelOffersRoute = AppFuelOffersImport.update({
  id: '/offers',
  path: '/offers',
  getParentRoute: () => AppFuelRoute,
} as any)

const AppFuelKeyPortsRoute = AppFuelKeyPortsImport.update({
  id: '/key-ports',
  path: '/key-ports',
  getParentRoute: () => AppFuelRoute,
} as any)

const AppFuelGlobalPricesRoute = AppFuelGlobalPricesImport.update({
  id: '/global-prices',
  path: '/global-prices',
  getParentRoute: () => AppFuelRoute,
} as any)

const AppFuelDashboardRoute = AppFuelDashboardImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppFuelRoute,
} as any)

const AppFuelCreateRoute = AppFuelCreateImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AppFuelRoute,
} as any)

const AppFuelContractsRoute = AppFuelContractsImport.update({
  id: '/contracts',
  path: '/contracts',
  getParentRoute: () => AppFuelRoute,
} as any)

const AppFuelAssignmentsRoute = AppFuelAssignmentsImport.update({
  id: '/assignments',
  path: '/assignments',
  getParentRoute: () => AppFuelRoute,
} as any)

const AppCustomerGroupIdRoute = AppCustomerGroupIdImport.update({
  id: '/customer-group/$id',
  path: '/customer-group/$id',
  getParentRoute: () => AppRoute,
} as any)

const AppLubesSuppliersRoute = AppLubesSuppliersImport.update({
  id: '/suppliers',
  path: '/suppliers',
  getParentRoute: () => AppLubesRoute,
} as any)

const AppLubesStatisticsRoute = AppLubesStatisticsImport.update({
  id: '/statistics',
  path: '/statistics',
  getParentRoute: () => AppLubesRoute,
} as any)

const AppLubesProductsRoute = AppLubesProductsImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => AppLubesRoute,
} as any)

const AppLubesOrdersRoute = AppLubesOrdersImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AppLubesRoute,
} as any)

const AppLubesOffersRoute = AppLubesOffersImport.update({
  id: '/offers',
  path: '/offers',
  getParentRoute: () => AppLubesRoute,
} as any)

const AppLubesKeyPortsRoute = AppLubesKeyPortsImport.update({
  id: '/key-ports',
  path: '/key-ports',
  getParentRoute: () => AppLubesRoute,
} as any)

const AppLubesDemandRoute = AppLubesDemandImport.update({
  id: '/demand',
  path: '/demand',
  getParentRoute: () => AppLubesRoute,
} as any)

const AppLubesDashboardRoute = AppLubesDashboardImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppLubesRoute,
} as any)

const AppLubesCustomersRoute = AppLubesCustomersImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => AppLubesRoute,
} as any)

const AppLubesCompareRoute = AppLubesCompareImport.update({
  id: '/compare',
  path: '/compare',
  getParentRoute: () => AppLubesRoute,
} as any)

const AppFuelAgentsIndexRoute = AppFuelAgentsIndexImport.update({
  id: '/agents/',
  path: '/agents/',
  getParentRoute: () => AppFuelRoute,
} as any)

const AppLubesAgentsIndexRoute = AppLubesAgentsIndexImport.update({
  id: '/agents/',
  path: '/agents/',
  getParentRoute: () => AppLubesRoute,
} as any)

const AppUserDetailIdRoute = AppUserDetailIdImport.update({
  id: '/user/detail/$id',
  path: '/user/detail/$id',
  getParentRoute: () => AppRoute,
} as any)

const AppSupplierDetailIdRoute = AppSupplierDetailIdImport.update({
  id: '/supplier/detail/$id',
  path: '/supplier/detail/$id',
  getParentRoute: () => AppRoute,
} as any)

const AppPortDetailIdRoute = AppPortDetailIdImport.update({
  id: '/port/detail/$id',
  path: '/port/detail/$id',
  getParentRoute: () => AppRoute,
} as any)

const AppFuelVesselIdRoute = AppFuelVesselIdImport.update({
  id: '/vessel/$id',
  path: '/vessel/$id',
  getParentRoute: () => AppFuelRoute,
} as any)

const AppFuelPlanningDemandRoute = AppFuelPlanningDemandImport.update({
  id: '/planning/demand',
  path: '/planning/demand',
  getParentRoute: () => AppFuelRoute,
} as any)

const AppFuelPlanningBunkerPlanRoute = AppFuelPlanningBunkerPlanImport.update({
  id: '/planning/bunker-plan',
  path: '/planning/bunker-plan',
  getParentRoute: () => AppFuelRoute,
} as any)

const AppFuelOrderIdRoute = AppFuelOrderIdImport.update({
  id: '/order/$id',
  path: '/order/$id',
  getParentRoute: () => AppFuelRoute,
} as any)

const AppFuelOfferIdRoute = AppFuelOfferIdImport.update({
  id: '/offer/$id',
  path: '/offer/$id',
  getParentRoute: () => AppFuelRoute,
} as any)

const AppFuelAgentsIdRoute = AppFuelAgentsIdImport.update({
  id: '/agents/$id',
  path: '/agents/$id',
  getParentRoute: () => AppFuelRoute,
} as any)

const AppCustomerDetailIdRoute = AppCustomerDetailIdImport.update({
  id: '/customer/detail/$id',
  path: '/customer/detail/$id',
  getParentRoute: () => AppRoute,
} as any)

const AppLubesVesselIdRoute = AppLubesVesselIdImport.update({
  id: '/vessel/$id',
  path: '/vessel/$id',
  getParentRoute: () => AppLubesRoute,
} as any)

const AppLubesOrdersNewRoute = AppLubesOrdersNewImport.update({
  id: '/orders_/new',
  path: '/orders/new',
  getParentRoute: () => AppLubesRoute,
} as any)

const AppLubesOrderIdRoute = AppLubesOrderIdImport.update({
  id: '/order/$id',
  path: '/order/$id',
  getParentRoute: () => AppLubesRoute,
} as any)

const AppLubesOfferIdRoute = AppLubesOfferIdImport.update({
  id: '/offer/$id',
  path: '/offer/$id',
  getParentRoute: () => AppLubesRoute,
} as any)

const AppLubesAgentsIdRoute = AppLubesAgentsIdImport.update({
  id: '/agents/$id',
  path: '/agents/$id',
  getParentRoute: () => AppLubesRoute,
} as any)

const AppFuelOrderIdEditRoute = AppFuelOrderIdEditImport.update({
  id: '/order/$id_/edit',
  path: '/order/$id/edit',
  getParentRoute: () => AppFuelRoute,
} as any)

const AppFuelOfferIdQuoteRoute = AppFuelOfferIdQuoteImport.update({
  id: '/offer/$id_/quote',
  path: '/offer/$id/quote',
  getParentRoute: () => AppFuelRoute,
} as any)

const AppFuelOfferIdEditRoute = AppFuelOfferIdEditImport.update({
  id: '/offer/$id_/edit',
  path: '/offer/$id/edit',
  getParentRoute: () => AppFuelRoute,
} as any)

const AppLubesOrdersDraftIdRoute = AppLubesOrdersDraftIdImport.update({
  id: '/orders_/draft/$id',
  path: '/orders/draft/$id',
  getParentRoute: () => AppLubesRoute,
} as any)

const AppLubesOrderEditIdRoute = AppLubesOrderEditIdImport.update({
  id: '/order_/edit/$id',
  path: '/order/edit/$id',
  getParentRoute: () => AppLubesRoute,
} as any)

const AppLubesOfferIdQuoteRoute = AppLubesOfferIdQuoteImport.update({
  id: '/offer/$id_/quote',
  path: '/offer/$id/quote',
  getParentRoute: () => AppLubesRoute,
} as any)

const AppLubesOfferIdEditRoute = AppLubesOfferIdEditImport.update({
  id: '/offer/$id_/edit',
  path: '/offer/$id/edit',
  getParentRoute: () => AppLubesRoute,
} as any)

const AppFuelPlanningSolutionsVesselIdCaseNumberSolutionNumberRoute =
  AppFuelPlanningSolutionsVesselIdCaseNumberSolutionNumberImport.update({
    id: '/planning/solutions/$vesselId/$caseNumber/$solutionNumber',
    path: '/planning/solutions/$vesselId/$caseNumber/$solutionNumber',
    getParentRoute: () => AppFuelRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutImport
      parentRoute: typeof rootRoute
    }
    '/password-reset_': {
      id: '/password-reset_'
      path: '/password-reset'
      fullPath: '/password-reset'
      preLoaderRoute: typeof PasswordResetImport
      parentRoute: typeof rootRoute
    }
    '/set-new-password': {
      id: '/set-new-password'
      path: '/set-new-password'
      fullPath: '/set-new-password'
      preLoaderRoute: typeof SetNewPasswordImport
      parentRoute: typeof rootRoute
    }
    '/_app/_lubes': {
      id: '/_app/_lubes'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppLubesImport
      parentRoute: typeof AppImport
    }
    '/_app/assignments': {
      id: '/_app/assignments'
      path: '/assignments'
      fullPath: '/assignments'
      preLoaderRoute: typeof AppAssignmentsImport
      parentRoute: typeof AppImport
    }
    '/_app/customer-groups': {
      id: '/_app/customer-groups'
      path: '/customer-groups'
      fullPath: '/customer-groups'
      preLoaderRoute: typeof AppCustomerGroupsImport
      parentRoute: typeof AppImport
    }
    '/_app/fuel': {
      id: '/_app/fuel'
      path: '/fuel'
      fullPath: '/fuel'
      preLoaderRoute: typeof AppFuelImport
      parentRoute: typeof AppImport
    }
    '/_app/integrations': {
      id: '/_app/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof AppIntegrationsImport
      parentRoute: typeof AppImport
    }
    '/_app/ports': {
      id: '/_app/ports'
      path: '/ports'
      fullPath: '/ports'
      preLoaderRoute: typeof AppPortsImport
      parentRoute: typeof AppImport
    }
    '/_app/search': {
      id: '/_app/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AppSearchImport
      parentRoute: typeof AppImport
    }
    '/_app/supplier-groups': {
      id: '/_app/supplier-groups'
      path: '/supplier-groups'
      fullPath: '/supplier-groups'
      preLoaderRoute: typeof AppSupplierGroupsImport
      parentRoute: typeof AppImport
    }
    '/_app/users': {
      id: '/_app/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AppUsersImport
      parentRoute: typeof AppImport
    }
    '/_app/vessels': {
      id: '/_app/vessels'
      path: '/vessels'
      fullPath: '/vessels'
      preLoaderRoute: typeof AppVesselsImport
      parentRoute: typeof AppImport
    }
    '/limited-quotation/$anonymousQuotationId': {
      id: '/limited-quotation/$anonymousQuotationId'
      path: '/limited-quotation/$anonymousQuotationId'
      fullPath: '/limited-quotation/$anonymousQuotationId'
      preLoaderRoute: typeof LimitedQuotationAnonymousQuotationIdImport
      parentRoute: typeof rootRoute
    }
    '/_app/_lubes/compare': {
      id: '/_app/_lubes/compare'
      path: '/compare'
      fullPath: '/compare'
      preLoaderRoute: typeof AppLubesCompareImport
      parentRoute: typeof AppLubesImport
    }
    '/_app/_lubes/customers': {
      id: '/_app/_lubes/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof AppLubesCustomersImport
      parentRoute: typeof AppLubesImport
    }
    '/_app/_lubes/dashboard': {
      id: '/_app/_lubes/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppLubesDashboardImport
      parentRoute: typeof AppLubesImport
    }
    '/_app/_lubes/demand': {
      id: '/_app/_lubes/demand'
      path: '/demand'
      fullPath: '/demand'
      preLoaderRoute: typeof AppLubesDemandImport
      parentRoute: typeof AppLubesImport
    }
    '/_app/_lubes/key-ports': {
      id: '/_app/_lubes/key-ports'
      path: '/key-ports'
      fullPath: '/key-ports'
      preLoaderRoute: typeof AppLubesKeyPortsImport
      parentRoute: typeof AppLubesImport
    }
    '/_app/_lubes/offers': {
      id: '/_app/_lubes/offers'
      path: '/offers'
      fullPath: '/offers'
      preLoaderRoute: typeof AppLubesOffersImport
      parentRoute: typeof AppLubesImport
    }
    '/_app/_lubes/orders': {
      id: '/_app/_lubes/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof AppLubesOrdersImport
      parentRoute: typeof AppLubesImport
    }
    '/_app/_lubes/products': {
      id: '/_app/_lubes/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof AppLubesProductsImport
      parentRoute: typeof AppLubesImport
    }
    '/_app/_lubes/statistics': {
      id: '/_app/_lubes/statistics'
      path: '/statistics'
      fullPath: '/statistics'
      preLoaderRoute: typeof AppLubesStatisticsImport
      parentRoute: typeof AppLubesImport
    }
    '/_app/_lubes/suppliers': {
      id: '/_app/_lubes/suppliers'
      path: '/suppliers'
      fullPath: '/suppliers'
      preLoaderRoute: typeof AppLubesSuppliersImport
      parentRoute: typeof AppLubesImport
    }
    '/_app/customer-group/$id': {
      id: '/_app/customer-group/$id'
      path: '/customer-group/$id'
      fullPath: '/customer-group/$id'
      preLoaderRoute: typeof AppCustomerGroupIdImport
      parentRoute: typeof AppImport
    }
    '/_app/fuel/assignments': {
      id: '/_app/fuel/assignments'
      path: '/assignments'
      fullPath: '/fuel/assignments'
      preLoaderRoute: typeof AppFuelAssignmentsImport
      parentRoute: typeof AppFuelImport
    }
    '/_app/fuel/contracts': {
      id: '/_app/fuel/contracts'
      path: '/contracts'
      fullPath: '/fuel/contracts'
      preLoaderRoute: typeof AppFuelContractsImport
      parentRoute: typeof AppFuelImport
    }
    '/_app/fuel/create': {
      id: '/_app/fuel/create'
      path: '/create'
      fullPath: '/fuel/create'
      preLoaderRoute: typeof AppFuelCreateImport
      parentRoute: typeof AppFuelImport
    }
    '/_app/fuel/dashboard': {
      id: '/_app/fuel/dashboard'
      path: '/dashboard'
      fullPath: '/fuel/dashboard'
      preLoaderRoute: typeof AppFuelDashboardImport
      parentRoute: typeof AppFuelImport
    }
    '/_app/fuel/global-prices': {
      id: '/_app/fuel/global-prices'
      path: '/global-prices'
      fullPath: '/fuel/global-prices'
      preLoaderRoute: typeof AppFuelGlobalPricesImport
      parentRoute: typeof AppFuelImport
    }
    '/_app/fuel/key-ports': {
      id: '/_app/fuel/key-ports'
      path: '/key-ports'
      fullPath: '/fuel/key-ports'
      preLoaderRoute: typeof AppFuelKeyPortsImport
      parentRoute: typeof AppFuelImport
    }
    '/_app/fuel/offers': {
      id: '/_app/fuel/offers'
      path: '/offers'
      fullPath: '/fuel/offers'
      preLoaderRoute: typeof AppFuelOffersImport
      parentRoute: typeof AppFuelImport
    }
    '/_app/fuel/orders': {
      id: '/_app/fuel/orders'
      path: '/orders'
      fullPath: '/fuel/orders'
      preLoaderRoute: typeof AppFuelOrdersImport
      parentRoute: typeof AppFuelImport
    }
    '/_app/fuel/statistics': {
      id: '/_app/fuel/statistics'
      path: '/statistics'
      fullPath: '/fuel/statistics'
      preLoaderRoute: typeof AppFuelStatisticsImport
      parentRoute: typeof AppFuelImport
    }
    '/_app/fuel/vessels': {
      id: '/_app/fuel/vessels'
      path: '/vessels'
      fullPath: '/fuel/vessels'
      preLoaderRoute: typeof AppFuelVesselsImport
      parentRoute: typeof AppFuelImport
    }
    '/_app/supplier-group/$id': {
      id: '/_app/supplier-group/$id'
      path: '/supplier-group/$id'
      fullPath: '/supplier-group/$id'
      preLoaderRoute: typeof AppSupplierGroupIdImport
      parentRoute: typeof AppImport
    }
    '/offer/$offerId/approval-request': {
      id: '/offer/$offerId/approval-request'
      path: '/offer/$offerId/approval-request'
      fullPath: '/offer/$offerId/approval-request'
      preLoaderRoute: typeof OfferOfferIdApprovalRequestImport
      parentRoute: typeof rootRoute
    }
    '/onboard/$userId/$token': {
      id: '/onboard/$userId/$token'
      path: '/onboard/$userId/$token'
      fullPath: '/onboard/$userId/$token'
      preLoaderRoute: typeof OnboardUserIdTokenImport
      parentRoute: typeof rootRoute
    }
    '/_app/_lubes/agents/$id': {
      id: '/_app/_lubes/agents/$id'
      path: '/agents/$id'
      fullPath: '/agents/$id'
      preLoaderRoute: typeof AppLubesAgentsIdImport
      parentRoute: typeof AppLubesImport
    }
    '/_app/_lubes/offer/$id': {
      id: '/_app/_lubes/offer/$id'
      path: '/offer/$id'
      fullPath: '/offer/$id'
      preLoaderRoute: typeof AppLubesOfferIdImport
      parentRoute: typeof AppLubesImport
    }
    '/_app/_lubes/order/$id': {
      id: '/_app/_lubes/order/$id'
      path: '/order/$id'
      fullPath: '/order/$id'
      preLoaderRoute: typeof AppLubesOrderIdImport
      parentRoute: typeof AppLubesImport
    }
    '/_app/_lubes/orders_/new': {
      id: '/_app/_lubes/orders_/new'
      path: '/orders/new'
      fullPath: '/orders/new'
      preLoaderRoute: typeof AppLubesOrdersNewImport
      parentRoute: typeof AppLubesImport
    }
    '/_app/_lubes/vessel/$id': {
      id: '/_app/_lubes/vessel/$id'
      path: '/vessel/$id'
      fullPath: '/vessel/$id'
      preLoaderRoute: typeof AppLubesVesselIdImport
      parentRoute: typeof AppLubesImport
    }
    '/_app/customer/detail/$id': {
      id: '/_app/customer/detail/$id'
      path: '/customer/detail/$id'
      fullPath: '/customer/detail/$id'
      preLoaderRoute: typeof AppCustomerDetailIdImport
      parentRoute: typeof AppImport
    }
    '/_app/fuel/agents/$id': {
      id: '/_app/fuel/agents/$id'
      path: '/agents/$id'
      fullPath: '/fuel/agents/$id'
      preLoaderRoute: typeof AppFuelAgentsIdImport
      parentRoute: typeof AppFuelImport
    }
    '/_app/fuel/offer/$id': {
      id: '/_app/fuel/offer/$id'
      path: '/offer/$id'
      fullPath: '/fuel/offer/$id'
      preLoaderRoute: typeof AppFuelOfferIdImport
      parentRoute: typeof AppFuelImport
    }
    '/_app/fuel/order/$id': {
      id: '/_app/fuel/order/$id'
      path: '/order/$id'
      fullPath: '/fuel/order/$id'
      preLoaderRoute: typeof AppFuelOrderIdImport
      parentRoute: typeof AppFuelImport
    }
    '/_app/fuel/planning/bunker-plan': {
      id: '/_app/fuel/planning/bunker-plan'
      path: '/planning/bunker-plan'
      fullPath: '/fuel/planning/bunker-plan'
      preLoaderRoute: typeof AppFuelPlanningBunkerPlanImport
      parentRoute: typeof AppFuelImport
    }
    '/_app/fuel/planning/demand': {
      id: '/_app/fuel/planning/demand'
      path: '/planning/demand'
      fullPath: '/fuel/planning/demand'
      preLoaderRoute: typeof AppFuelPlanningDemandImport
      parentRoute: typeof AppFuelImport
    }
    '/_app/fuel/vessel/$id': {
      id: '/_app/fuel/vessel/$id'
      path: '/vessel/$id'
      fullPath: '/fuel/vessel/$id'
      preLoaderRoute: typeof AppFuelVesselIdImport
      parentRoute: typeof AppFuelImport
    }
    '/_app/port/detail/$id': {
      id: '/_app/port/detail/$id'
      path: '/port/detail/$id'
      fullPath: '/port/detail/$id'
      preLoaderRoute: typeof AppPortDetailIdImport
      parentRoute: typeof AppImport
    }
    '/_app/supplier/detail/$id': {
      id: '/_app/supplier/detail/$id'
      path: '/supplier/detail/$id'
      fullPath: '/supplier/detail/$id'
      preLoaderRoute: typeof AppSupplierDetailIdImport
      parentRoute: typeof AppImport
    }
    '/_app/user/detail/$id': {
      id: '/_app/user/detail/$id'
      path: '/user/detail/$id'
      fullPath: '/user/detail/$id'
      preLoaderRoute: typeof AppUserDetailIdImport
      parentRoute: typeof AppImport
    }
    '/_app/_lubes/agents/': {
      id: '/_app/_lubes/agents/'
      path: '/agents'
      fullPath: '/agents'
      preLoaderRoute: typeof AppLubesAgentsIndexImport
      parentRoute: typeof AppLubesImport
    }
    '/_app/fuel/agents/': {
      id: '/_app/fuel/agents/'
      path: '/agents'
      fullPath: '/fuel/agents'
      preLoaderRoute: typeof AppFuelAgentsIndexImport
      parentRoute: typeof AppFuelImport
    }
    '/_app/_lubes/offer/$id_/edit': {
      id: '/_app/_lubes/offer/$id_/edit'
      path: '/offer/$id/edit'
      fullPath: '/offer/$id/edit'
      preLoaderRoute: typeof AppLubesOfferIdEditImport
      parentRoute: typeof AppLubesImport
    }
    '/_app/_lubes/offer/$id_/quote': {
      id: '/_app/_lubes/offer/$id_/quote'
      path: '/offer/$id/quote'
      fullPath: '/offer/$id/quote'
      preLoaderRoute: typeof AppLubesOfferIdQuoteImport
      parentRoute: typeof AppLubesImport
    }
    '/_app/_lubes/order_/edit/$id': {
      id: '/_app/_lubes/order_/edit/$id'
      path: '/order/edit/$id'
      fullPath: '/order/edit/$id'
      preLoaderRoute: typeof AppLubesOrderEditIdImport
      parentRoute: typeof AppLubesImport
    }
    '/_app/_lubes/orders_/draft/$id': {
      id: '/_app/_lubes/orders_/draft/$id'
      path: '/orders/draft/$id'
      fullPath: '/orders/draft/$id'
      preLoaderRoute: typeof AppLubesOrdersDraftIdImport
      parentRoute: typeof AppLubesImport
    }
    '/_app/fuel/offer/$id_/edit': {
      id: '/_app/fuel/offer/$id_/edit'
      path: '/offer/$id/edit'
      fullPath: '/fuel/offer/$id/edit'
      preLoaderRoute: typeof AppFuelOfferIdEditImport
      parentRoute: typeof AppFuelImport
    }
    '/_app/fuel/offer/$id_/quote': {
      id: '/_app/fuel/offer/$id_/quote'
      path: '/offer/$id/quote'
      fullPath: '/fuel/offer/$id/quote'
      preLoaderRoute: typeof AppFuelOfferIdQuoteImport
      parentRoute: typeof AppFuelImport
    }
    '/_app/fuel/order/$id_/edit': {
      id: '/_app/fuel/order/$id_/edit'
      path: '/order/$id/edit'
      fullPath: '/fuel/order/$id/edit'
      preLoaderRoute: typeof AppFuelOrderIdEditImport
      parentRoute: typeof AppFuelImport
    }
    '/_app/fuel/planning/solutions/$vesselId/$caseNumber/$solutionNumber': {
      id: '/_app/fuel/planning/solutions/$vesselId/$caseNumber/$solutionNumber'
      path: '/planning/solutions/$vesselId/$caseNumber/$solutionNumber'
      fullPath: '/fuel/planning/solutions/$vesselId/$caseNumber/$solutionNumber'
      preLoaderRoute: typeof AppFuelPlanningSolutionsVesselIdCaseNumberSolutionNumberImport
      parentRoute: typeof AppFuelImport
    }
  }
}

// Create and export the route tree

interface AppLubesRouteChildren {
  AppLubesCompareRoute: typeof AppLubesCompareRoute
  AppLubesCustomersRoute: typeof AppLubesCustomersRoute
  AppLubesDashboardRoute: typeof AppLubesDashboardRoute
  AppLubesDemandRoute: typeof AppLubesDemandRoute
  AppLubesKeyPortsRoute: typeof AppLubesKeyPortsRoute
  AppLubesOffersRoute: typeof AppLubesOffersRoute
  AppLubesOrdersRoute: typeof AppLubesOrdersRoute
  AppLubesProductsRoute: typeof AppLubesProductsRoute
  AppLubesStatisticsRoute: typeof AppLubesStatisticsRoute
  AppLubesSuppliersRoute: typeof AppLubesSuppliersRoute
  AppLubesAgentsIdRoute: typeof AppLubesAgentsIdRoute
  AppLubesOfferIdRoute: typeof AppLubesOfferIdRoute
  AppLubesOrderIdRoute: typeof AppLubesOrderIdRoute
  AppLubesOrdersNewRoute: typeof AppLubesOrdersNewRoute
  AppLubesVesselIdRoute: typeof AppLubesVesselIdRoute
  AppLubesAgentsIndexRoute: typeof AppLubesAgentsIndexRoute
  AppLubesOfferIdEditRoute: typeof AppLubesOfferIdEditRoute
  AppLubesOfferIdQuoteRoute: typeof AppLubesOfferIdQuoteRoute
  AppLubesOrderEditIdRoute: typeof AppLubesOrderEditIdRoute
  AppLubesOrdersDraftIdRoute: typeof AppLubesOrdersDraftIdRoute
}

const AppLubesRouteChildren: AppLubesRouteChildren = {
  AppLubesCompareRoute: AppLubesCompareRoute,
  AppLubesCustomersRoute: AppLubesCustomersRoute,
  AppLubesDashboardRoute: AppLubesDashboardRoute,
  AppLubesDemandRoute: AppLubesDemandRoute,
  AppLubesKeyPortsRoute: AppLubesKeyPortsRoute,
  AppLubesOffersRoute: AppLubesOffersRoute,
  AppLubesOrdersRoute: AppLubesOrdersRoute,
  AppLubesProductsRoute: AppLubesProductsRoute,
  AppLubesStatisticsRoute: AppLubesStatisticsRoute,
  AppLubesSuppliersRoute: AppLubesSuppliersRoute,
  AppLubesAgentsIdRoute: AppLubesAgentsIdRoute,
  AppLubesOfferIdRoute: AppLubesOfferIdRoute,
  AppLubesOrderIdRoute: AppLubesOrderIdRoute,
  AppLubesOrdersNewRoute: AppLubesOrdersNewRoute,
  AppLubesVesselIdRoute: AppLubesVesselIdRoute,
  AppLubesAgentsIndexRoute: AppLubesAgentsIndexRoute,
  AppLubesOfferIdEditRoute: AppLubesOfferIdEditRoute,
  AppLubesOfferIdQuoteRoute: AppLubesOfferIdQuoteRoute,
  AppLubesOrderEditIdRoute: AppLubesOrderEditIdRoute,
  AppLubesOrdersDraftIdRoute: AppLubesOrdersDraftIdRoute,
}

const AppLubesRouteWithChildren = AppLubesRoute._addFileChildren(
  AppLubesRouteChildren,
)

interface AppFuelRouteChildren {
  AppFuelAssignmentsRoute: typeof AppFuelAssignmentsRoute
  AppFuelContractsRoute: typeof AppFuelContractsRoute
  AppFuelCreateRoute: typeof AppFuelCreateRoute
  AppFuelDashboardRoute: typeof AppFuelDashboardRoute
  AppFuelGlobalPricesRoute: typeof AppFuelGlobalPricesRoute
  AppFuelKeyPortsRoute: typeof AppFuelKeyPortsRoute
  AppFuelOffersRoute: typeof AppFuelOffersRoute
  AppFuelOrdersRoute: typeof AppFuelOrdersRoute
  AppFuelStatisticsRoute: typeof AppFuelStatisticsRoute
  AppFuelVesselsRoute: typeof AppFuelVesselsRoute
  AppFuelAgentsIdRoute: typeof AppFuelAgentsIdRoute
  AppFuelOfferIdRoute: typeof AppFuelOfferIdRoute
  AppFuelOrderIdRoute: typeof AppFuelOrderIdRoute
  AppFuelPlanningBunkerPlanRoute: typeof AppFuelPlanningBunkerPlanRoute
  AppFuelPlanningDemandRoute: typeof AppFuelPlanningDemandRoute
  AppFuelVesselIdRoute: typeof AppFuelVesselIdRoute
  AppFuelAgentsIndexRoute: typeof AppFuelAgentsIndexRoute
  AppFuelOfferIdEditRoute: typeof AppFuelOfferIdEditRoute
  AppFuelOfferIdQuoteRoute: typeof AppFuelOfferIdQuoteRoute
  AppFuelOrderIdEditRoute: typeof AppFuelOrderIdEditRoute
  AppFuelPlanningSolutionsVesselIdCaseNumberSolutionNumberRoute: typeof AppFuelPlanningSolutionsVesselIdCaseNumberSolutionNumberRoute
}

const AppFuelRouteChildren: AppFuelRouteChildren = {
  AppFuelAssignmentsRoute: AppFuelAssignmentsRoute,
  AppFuelContractsRoute: AppFuelContractsRoute,
  AppFuelCreateRoute: AppFuelCreateRoute,
  AppFuelDashboardRoute: AppFuelDashboardRoute,
  AppFuelGlobalPricesRoute: AppFuelGlobalPricesRoute,
  AppFuelKeyPortsRoute: AppFuelKeyPortsRoute,
  AppFuelOffersRoute: AppFuelOffersRoute,
  AppFuelOrdersRoute: AppFuelOrdersRoute,
  AppFuelStatisticsRoute: AppFuelStatisticsRoute,
  AppFuelVesselsRoute: AppFuelVesselsRoute,
  AppFuelAgentsIdRoute: AppFuelAgentsIdRoute,
  AppFuelOfferIdRoute: AppFuelOfferIdRoute,
  AppFuelOrderIdRoute: AppFuelOrderIdRoute,
  AppFuelPlanningBunkerPlanRoute: AppFuelPlanningBunkerPlanRoute,
  AppFuelPlanningDemandRoute: AppFuelPlanningDemandRoute,
  AppFuelVesselIdRoute: AppFuelVesselIdRoute,
  AppFuelAgentsIndexRoute: AppFuelAgentsIndexRoute,
  AppFuelOfferIdEditRoute: AppFuelOfferIdEditRoute,
  AppFuelOfferIdQuoteRoute: AppFuelOfferIdQuoteRoute,
  AppFuelOrderIdEditRoute: AppFuelOrderIdEditRoute,
  AppFuelPlanningSolutionsVesselIdCaseNumberSolutionNumberRoute:
    AppFuelPlanningSolutionsVesselIdCaseNumberSolutionNumberRoute,
}

const AppFuelRouteWithChildren =
  AppFuelRoute._addFileChildren(AppFuelRouteChildren)

interface AppRouteChildren {
  AppLubesRoute: typeof AppLubesRouteWithChildren
  AppAssignmentsRoute: typeof AppAssignmentsRoute
  AppCustomerGroupsRoute: typeof AppCustomerGroupsRoute
  AppFuelRoute: typeof AppFuelRouteWithChildren
  AppIntegrationsRoute: typeof AppIntegrationsRoute
  AppPortsRoute: typeof AppPortsRoute
  AppSearchRoute: typeof AppSearchRoute
  AppSupplierGroupsRoute: typeof AppSupplierGroupsRoute
  AppUsersRoute: typeof AppUsersRoute
  AppVesselsRoute: typeof AppVesselsRoute
  AppCustomerGroupIdRoute: typeof AppCustomerGroupIdRoute
  AppSupplierGroupIdRoute: typeof AppSupplierGroupIdRoute
  AppCustomerDetailIdRoute: typeof AppCustomerDetailIdRoute
  AppPortDetailIdRoute: typeof AppPortDetailIdRoute
  AppSupplierDetailIdRoute: typeof AppSupplierDetailIdRoute
  AppUserDetailIdRoute: typeof AppUserDetailIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppLubesRoute: AppLubesRouteWithChildren,
  AppAssignmentsRoute: AppAssignmentsRoute,
  AppCustomerGroupsRoute: AppCustomerGroupsRoute,
  AppFuelRoute: AppFuelRouteWithChildren,
  AppIntegrationsRoute: AppIntegrationsRoute,
  AppPortsRoute: AppPortsRoute,
  AppSearchRoute: AppSearchRoute,
  AppSupplierGroupsRoute: AppSupplierGroupsRoute,
  AppUsersRoute: AppUsersRoute,
  AppVesselsRoute: AppVesselsRoute,
  AppCustomerGroupIdRoute: AppCustomerGroupIdRoute,
  AppSupplierGroupIdRoute: AppSupplierGroupIdRoute,
  AppCustomerDetailIdRoute: AppCustomerDetailIdRoute,
  AppPortDetailIdRoute: AppPortDetailIdRoute,
  AppSupplierDetailIdRoute: AppSupplierDetailIdRoute,
  AppUserDetailIdRoute: AppUserDetailIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof AppLubesRouteWithChildren
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/password-reset': typeof PasswordResetRoute
  '/set-new-password': typeof SetNewPasswordRoute
  '/assignments': typeof AppAssignmentsRoute
  '/customer-groups': typeof AppCustomerGroupsRoute
  '/fuel': typeof AppFuelRouteWithChildren
  '/integrations': typeof AppIntegrationsRoute
  '/ports': typeof AppPortsRoute
  '/search': typeof AppSearchRoute
  '/supplier-groups': typeof AppSupplierGroupsRoute
  '/users': typeof AppUsersRoute
  '/vessels': typeof AppVesselsRoute
  '/limited-quotation/$anonymousQuotationId': typeof LimitedQuotationAnonymousQuotationIdRoute
  '/compare': typeof AppLubesCompareRoute
  '/customers': typeof AppLubesCustomersRoute
  '/dashboard': typeof AppLubesDashboardRoute
  '/demand': typeof AppLubesDemandRoute
  '/key-ports': typeof AppLubesKeyPortsRoute
  '/offers': typeof AppLubesOffersRoute
  '/orders': typeof AppLubesOrdersRoute
  '/products': typeof AppLubesProductsRoute
  '/statistics': typeof AppLubesStatisticsRoute
  '/suppliers': typeof AppLubesSuppliersRoute
  '/customer-group/$id': typeof AppCustomerGroupIdRoute
  '/fuel/assignments': typeof AppFuelAssignmentsRoute
  '/fuel/contracts': typeof AppFuelContractsRoute
  '/fuel/create': typeof AppFuelCreateRoute
  '/fuel/dashboard': typeof AppFuelDashboardRoute
  '/fuel/global-prices': typeof AppFuelGlobalPricesRoute
  '/fuel/key-ports': typeof AppFuelKeyPortsRoute
  '/fuel/offers': typeof AppFuelOffersRoute
  '/fuel/orders': typeof AppFuelOrdersRoute
  '/fuel/statistics': typeof AppFuelStatisticsRoute
  '/fuel/vessels': typeof AppFuelVesselsRoute
  '/supplier-group/$id': typeof AppSupplierGroupIdRoute
  '/offer/$offerId/approval-request': typeof OfferOfferIdApprovalRequestRoute
  '/onboard/$userId/$token': typeof OnboardUserIdTokenRoute
  '/agents/$id': typeof AppLubesAgentsIdRoute
  '/offer/$id': typeof AppLubesOfferIdRoute
  '/order/$id': typeof AppLubesOrderIdRoute
  '/orders/new': typeof AppLubesOrdersNewRoute
  '/vessel/$id': typeof AppLubesVesselIdRoute
  '/customer/detail/$id': typeof AppCustomerDetailIdRoute
  '/fuel/agents/$id': typeof AppFuelAgentsIdRoute
  '/fuel/offer/$id': typeof AppFuelOfferIdRoute
  '/fuel/order/$id': typeof AppFuelOrderIdRoute
  '/fuel/planning/bunker-plan': typeof AppFuelPlanningBunkerPlanRoute
  '/fuel/planning/demand': typeof AppFuelPlanningDemandRoute
  '/fuel/vessel/$id': typeof AppFuelVesselIdRoute
  '/port/detail/$id': typeof AppPortDetailIdRoute
  '/supplier/detail/$id': typeof AppSupplierDetailIdRoute
  '/user/detail/$id': typeof AppUserDetailIdRoute
  '/agents': typeof AppLubesAgentsIndexRoute
  '/fuel/agents': typeof AppFuelAgentsIndexRoute
  '/offer/$id/edit': typeof AppLubesOfferIdEditRoute
  '/offer/$id/quote': typeof AppLubesOfferIdQuoteRoute
  '/order/edit/$id': typeof AppLubesOrderEditIdRoute
  '/orders/draft/$id': typeof AppLubesOrdersDraftIdRoute
  '/fuel/offer/$id/edit': typeof AppFuelOfferIdEditRoute
  '/fuel/offer/$id/quote': typeof AppFuelOfferIdQuoteRoute
  '/fuel/order/$id/edit': typeof AppFuelOrderIdEditRoute
  '/fuel/planning/solutions/$vesselId/$caseNumber/$solutionNumber': typeof AppFuelPlanningSolutionsVesselIdCaseNumberSolutionNumberRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof AppLubesRouteWithChildren
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/password-reset': typeof PasswordResetRoute
  '/set-new-password': typeof SetNewPasswordRoute
  '/assignments': typeof AppAssignmentsRoute
  '/customer-groups': typeof AppCustomerGroupsRoute
  '/fuel': typeof AppFuelRouteWithChildren
  '/integrations': typeof AppIntegrationsRoute
  '/ports': typeof AppPortsRoute
  '/search': typeof AppSearchRoute
  '/supplier-groups': typeof AppSupplierGroupsRoute
  '/users': typeof AppUsersRoute
  '/vessels': typeof AppVesselsRoute
  '/limited-quotation/$anonymousQuotationId': typeof LimitedQuotationAnonymousQuotationIdRoute
  '/compare': typeof AppLubesCompareRoute
  '/customers': typeof AppLubesCustomersRoute
  '/dashboard': typeof AppLubesDashboardRoute
  '/demand': typeof AppLubesDemandRoute
  '/key-ports': typeof AppLubesKeyPortsRoute
  '/offers': typeof AppLubesOffersRoute
  '/orders': typeof AppLubesOrdersRoute
  '/products': typeof AppLubesProductsRoute
  '/statistics': typeof AppLubesStatisticsRoute
  '/suppliers': typeof AppLubesSuppliersRoute
  '/customer-group/$id': typeof AppCustomerGroupIdRoute
  '/fuel/assignments': typeof AppFuelAssignmentsRoute
  '/fuel/contracts': typeof AppFuelContractsRoute
  '/fuel/create': typeof AppFuelCreateRoute
  '/fuel/dashboard': typeof AppFuelDashboardRoute
  '/fuel/global-prices': typeof AppFuelGlobalPricesRoute
  '/fuel/key-ports': typeof AppFuelKeyPortsRoute
  '/fuel/offers': typeof AppFuelOffersRoute
  '/fuel/orders': typeof AppFuelOrdersRoute
  '/fuel/statistics': typeof AppFuelStatisticsRoute
  '/fuel/vessels': typeof AppFuelVesselsRoute
  '/supplier-group/$id': typeof AppSupplierGroupIdRoute
  '/offer/$offerId/approval-request': typeof OfferOfferIdApprovalRequestRoute
  '/onboard/$userId/$token': typeof OnboardUserIdTokenRoute
  '/agents/$id': typeof AppLubesAgentsIdRoute
  '/offer/$id': typeof AppLubesOfferIdRoute
  '/order/$id': typeof AppLubesOrderIdRoute
  '/orders/new': typeof AppLubesOrdersNewRoute
  '/vessel/$id': typeof AppLubesVesselIdRoute
  '/customer/detail/$id': typeof AppCustomerDetailIdRoute
  '/fuel/agents/$id': typeof AppFuelAgentsIdRoute
  '/fuel/offer/$id': typeof AppFuelOfferIdRoute
  '/fuel/order/$id': typeof AppFuelOrderIdRoute
  '/fuel/planning/bunker-plan': typeof AppFuelPlanningBunkerPlanRoute
  '/fuel/planning/demand': typeof AppFuelPlanningDemandRoute
  '/fuel/vessel/$id': typeof AppFuelVesselIdRoute
  '/port/detail/$id': typeof AppPortDetailIdRoute
  '/supplier/detail/$id': typeof AppSupplierDetailIdRoute
  '/user/detail/$id': typeof AppUserDetailIdRoute
  '/agents': typeof AppLubesAgentsIndexRoute
  '/fuel/agents': typeof AppFuelAgentsIndexRoute
  '/offer/$id/edit': typeof AppLubesOfferIdEditRoute
  '/offer/$id/quote': typeof AppLubesOfferIdQuoteRoute
  '/order/edit/$id': typeof AppLubesOrderEditIdRoute
  '/orders/draft/$id': typeof AppLubesOrdersDraftIdRoute
  '/fuel/offer/$id/edit': typeof AppFuelOfferIdEditRoute
  '/fuel/offer/$id/quote': typeof AppFuelOfferIdQuoteRoute
  '/fuel/order/$id/edit': typeof AppFuelOrderIdEditRoute
  '/fuel/planning/solutions/$vesselId/$caseNumber/$solutionNumber': typeof AppFuelPlanningSolutionsVesselIdCaseNumberSolutionNumberRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/password-reset_': typeof PasswordResetRoute
  '/set-new-password': typeof SetNewPasswordRoute
  '/_app/_lubes': typeof AppLubesRouteWithChildren
  '/_app/assignments': typeof AppAssignmentsRoute
  '/_app/customer-groups': typeof AppCustomerGroupsRoute
  '/_app/fuel': typeof AppFuelRouteWithChildren
  '/_app/integrations': typeof AppIntegrationsRoute
  '/_app/ports': typeof AppPortsRoute
  '/_app/search': typeof AppSearchRoute
  '/_app/supplier-groups': typeof AppSupplierGroupsRoute
  '/_app/users': typeof AppUsersRoute
  '/_app/vessels': typeof AppVesselsRoute
  '/limited-quotation/$anonymousQuotationId': typeof LimitedQuotationAnonymousQuotationIdRoute
  '/_app/_lubes/compare': typeof AppLubesCompareRoute
  '/_app/_lubes/customers': typeof AppLubesCustomersRoute
  '/_app/_lubes/dashboard': typeof AppLubesDashboardRoute
  '/_app/_lubes/demand': typeof AppLubesDemandRoute
  '/_app/_lubes/key-ports': typeof AppLubesKeyPortsRoute
  '/_app/_lubes/offers': typeof AppLubesOffersRoute
  '/_app/_lubes/orders': typeof AppLubesOrdersRoute
  '/_app/_lubes/products': typeof AppLubesProductsRoute
  '/_app/_lubes/statistics': typeof AppLubesStatisticsRoute
  '/_app/_lubes/suppliers': typeof AppLubesSuppliersRoute
  '/_app/customer-group/$id': typeof AppCustomerGroupIdRoute
  '/_app/fuel/assignments': typeof AppFuelAssignmentsRoute
  '/_app/fuel/contracts': typeof AppFuelContractsRoute
  '/_app/fuel/create': typeof AppFuelCreateRoute
  '/_app/fuel/dashboard': typeof AppFuelDashboardRoute
  '/_app/fuel/global-prices': typeof AppFuelGlobalPricesRoute
  '/_app/fuel/key-ports': typeof AppFuelKeyPortsRoute
  '/_app/fuel/offers': typeof AppFuelOffersRoute
  '/_app/fuel/orders': typeof AppFuelOrdersRoute
  '/_app/fuel/statistics': typeof AppFuelStatisticsRoute
  '/_app/fuel/vessels': typeof AppFuelVesselsRoute
  '/_app/supplier-group/$id': typeof AppSupplierGroupIdRoute
  '/offer/$offerId/approval-request': typeof OfferOfferIdApprovalRequestRoute
  '/onboard/$userId/$token': typeof OnboardUserIdTokenRoute
  '/_app/_lubes/agents/$id': typeof AppLubesAgentsIdRoute
  '/_app/_lubes/offer/$id': typeof AppLubesOfferIdRoute
  '/_app/_lubes/order/$id': typeof AppLubesOrderIdRoute
  '/_app/_lubes/orders_/new': typeof AppLubesOrdersNewRoute
  '/_app/_lubes/vessel/$id': typeof AppLubesVesselIdRoute
  '/_app/customer/detail/$id': typeof AppCustomerDetailIdRoute
  '/_app/fuel/agents/$id': typeof AppFuelAgentsIdRoute
  '/_app/fuel/offer/$id': typeof AppFuelOfferIdRoute
  '/_app/fuel/order/$id': typeof AppFuelOrderIdRoute
  '/_app/fuel/planning/bunker-plan': typeof AppFuelPlanningBunkerPlanRoute
  '/_app/fuel/planning/demand': typeof AppFuelPlanningDemandRoute
  '/_app/fuel/vessel/$id': typeof AppFuelVesselIdRoute
  '/_app/port/detail/$id': typeof AppPortDetailIdRoute
  '/_app/supplier/detail/$id': typeof AppSupplierDetailIdRoute
  '/_app/user/detail/$id': typeof AppUserDetailIdRoute
  '/_app/_lubes/agents/': typeof AppLubesAgentsIndexRoute
  '/_app/fuel/agents/': typeof AppFuelAgentsIndexRoute
  '/_app/_lubes/offer/$id_/edit': typeof AppLubesOfferIdEditRoute
  '/_app/_lubes/offer/$id_/quote': typeof AppLubesOfferIdQuoteRoute
  '/_app/_lubes/order_/edit/$id': typeof AppLubesOrderEditIdRoute
  '/_app/_lubes/orders_/draft/$id': typeof AppLubesOrdersDraftIdRoute
  '/_app/fuel/offer/$id_/edit': typeof AppFuelOfferIdEditRoute
  '/_app/fuel/offer/$id_/quote': typeof AppFuelOfferIdQuoteRoute
  '/_app/fuel/order/$id_/edit': typeof AppFuelOrderIdEditRoute
  '/_app/fuel/planning/solutions/$vesselId/$caseNumber/$solutionNumber': typeof AppFuelPlanningSolutionsVesselIdCaseNumberSolutionNumberRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/login'
    | '/logout'
    | '/password-reset'
    | '/set-new-password'
    | '/assignments'
    | '/customer-groups'
    | '/fuel'
    | '/integrations'
    | '/ports'
    | '/search'
    | '/supplier-groups'
    | '/users'
    | '/vessels'
    | '/limited-quotation/$anonymousQuotationId'
    | '/compare'
    | '/customers'
    | '/dashboard'
    | '/demand'
    | '/key-ports'
    | '/offers'
    | '/orders'
    | '/products'
    | '/statistics'
    | '/suppliers'
    | '/customer-group/$id'
    | '/fuel/assignments'
    | '/fuel/contracts'
    | '/fuel/create'
    | '/fuel/dashboard'
    | '/fuel/global-prices'
    | '/fuel/key-ports'
    | '/fuel/offers'
    | '/fuel/orders'
    | '/fuel/statistics'
    | '/fuel/vessels'
    | '/supplier-group/$id'
    | '/offer/$offerId/approval-request'
    | '/onboard/$userId/$token'
    | '/agents/$id'
    | '/offer/$id'
    | '/order/$id'
    | '/orders/new'
    | '/vessel/$id'
    | '/customer/detail/$id'
    | '/fuel/agents/$id'
    | '/fuel/offer/$id'
    | '/fuel/order/$id'
    | '/fuel/planning/bunker-plan'
    | '/fuel/planning/demand'
    | '/fuel/vessel/$id'
    | '/port/detail/$id'
    | '/supplier/detail/$id'
    | '/user/detail/$id'
    | '/agents'
    | '/fuel/agents'
    | '/offer/$id/edit'
    | '/offer/$id/quote'
    | '/order/edit/$id'
    | '/orders/draft/$id'
    | '/fuel/offer/$id/edit'
    | '/fuel/offer/$id/quote'
    | '/fuel/order/$id/edit'
    | '/fuel/planning/solutions/$vesselId/$caseNumber/$solutionNumber'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/login'
    | '/logout'
    | '/password-reset'
    | '/set-new-password'
    | '/assignments'
    | '/customer-groups'
    | '/fuel'
    | '/integrations'
    | '/ports'
    | '/search'
    | '/supplier-groups'
    | '/users'
    | '/vessels'
    | '/limited-quotation/$anonymousQuotationId'
    | '/compare'
    | '/customers'
    | '/dashboard'
    | '/demand'
    | '/key-ports'
    | '/offers'
    | '/orders'
    | '/products'
    | '/statistics'
    | '/suppliers'
    | '/customer-group/$id'
    | '/fuel/assignments'
    | '/fuel/contracts'
    | '/fuel/create'
    | '/fuel/dashboard'
    | '/fuel/global-prices'
    | '/fuel/key-ports'
    | '/fuel/offers'
    | '/fuel/orders'
    | '/fuel/statistics'
    | '/fuel/vessels'
    | '/supplier-group/$id'
    | '/offer/$offerId/approval-request'
    | '/onboard/$userId/$token'
    | '/agents/$id'
    | '/offer/$id'
    | '/order/$id'
    | '/orders/new'
    | '/vessel/$id'
    | '/customer/detail/$id'
    | '/fuel/agents/$id'
    | '/fuel/offer/$id'
    | '/fuel/order/$id'
    | '/fuel/planning/bunker-plan'
    | '/fuel/planning/demand'
    | '/fuel/vessel/$id'
    | '/port/detail/$id'
    | '/supplier/detail/$id'
    | '/user/detail/$id'
    | '/agents'
    | '/fuel/agents'
    | '/offer/$id/edit'
    | '/offer/$id/quote'
    | '/order/edit/$id'
    | '/orders/draft/$id'
    | '/fuel/offer/$id/edit'
    | '/fuel/offer/$id/quote'
    | '/fuel/order/$id/edit'
    | '/fuel/planning/solutions/$vesselId/$caseNumber/$solutionNumber'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/login'
    | '/logout'
    | '/password-reset_'
    | '/set-new-password'
    | '/_app/_lubes'
    | '/_app/assignments'
    | '/_app/customer-groups'
    | '/_app/fuel'
    | '/_app/integrations'
    | '/_app/ports'
    | '/_app/search'
    | '/_app/supplier-groups'
    | '/_app/users'
    | '/_app/vessels'
    | '/limited-quotation/$anonymousQuotationId'
    | '/_app/_lubes/compare'
    | '/_app/_lubes/customers'
    | '/_app/_lubes/dashboard'
    | '/_app/_lubes/demand'
    | '/_app/_lubes/key-ports'
    | '/_app/_lubes/offers'
    | '/_app/_lubes/orders'
    | '/_app/_lubes/products'
    | '/_app/_lubes/statistics'
    | '/_app/_lubes/suppliers'
    | '/_app/customer-group/$id'
    | '/_app/fuel/assignments'
    | '/_app/fuel/contracts'
    | '/_app/fuel/create'
    | '/_app/fuel/dashboard'
    | '/_app/fuel/global-prices'
    | '/_app/fuel/key-ports'
    | '/_app/fuel/offers'
    | '/_app/fuel/orders'
    | '/_app/fuel/statistics'
    | '/_app/fuel/vessels'
    | '/_app/supplier-group/$id'
    | '/offer/$offerId/approval-request'
    | '/onboard/$userId/$token'
    | '/_app/_lubes/agents/$id'
    | '/_app/_lubes/offer/$id'
    | '/_app/_lubes/order/$id'
    | '/_app/_lubes/orders_/new'
    | '/_app/_lubes/vessel/$id'
    | '/_app/customer/detail/$id'
    | '/_app/fuel/agents/$id'
    | '/_app/fuel/offer/$id'
    | '/_app/fuel/order/$id'
    | '/_app/fuel/planning/bunker-plan'
    | '/_app/fuel/planning/demand'
    | '/_app/fuel/vessel/$id'
    | '/_app/port/detail/$id'
    | '/_app/supplier/detail/$id'
    | '/_app/user/detail/$id'
    | '/_app/_lubes/agents/'
    | '/_app/fuel/agents/'
    | '/_app/_lubes/offer/$id_/edit'
    | '/_app/_lubes/offer/$id_/quote'
    | '/_app/_lubes/order_/edit/$id'
    | '/_app/_lubes/orders_/draft/$id'
    | '/_app/fuel/offer/$id_/edit'
    | '/_app/fuel/offer/$id_/quote'
    | '/_app/fuel/order/$id_/edit'
    | '/_app/fuel/planning/solutions/$vesselId/$caseNumber/$solutionNumber'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  PasswordResetRoute: typeof PasswordResetRoute
  SetNewPasswordRoute: typeof SetNewPasswordRoute
  LimitedQuotationAnonymousQuotationIdRoute: typeof LimitedQuotationAnonymousQuotationIdRoute
  OfferOfferIdApprovalRequestRoute: typeof OfferOfferIdApprovalRequestRoute
  OnboardUserIdTokenRoute: typeof OnboardUserIdTokenRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  PasswordResetRoute: PasswordResetRoute,
  SetNewPasswordRoute: SetNewPasswordRoute,
  LimitedQuotationAnonymousQuotationIdRoute:
    LimitedQuotationAnonymousQuotationIdRoute,
  OfferOfferIdApprovalRequestRoute: OfferOfferIdApprovalRequestRoute,
  OnboardUserIdTokenRoute: OnboardUserIdTokenRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_app",
        "/login",
        "/logout",
        "/password-reset_",
        "/set-new-password",
        "/limited-quotation/$anonymousQuotationId",
        "/offer/$offerId/approval-request",
        "/onboard/$userId/$token"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_app": {
      "filePath": "_app.tsx",
      "children": [
        "/_app/_lubes",
        "/_app/assignments",
        "/_app/customer-groups",
        "/_app/fuel",
        "/_app/integrations",
        "/_app/ports",
        "/_app/search",
        "/_app/supplier-groups",
        "/_app/users",
        "/_app/vessels",
        "/_app/customer-group/$id",
        "/_app/supplier-group/$id",
        "/_app/customer/detail/$id",
        "/_app/port/detail/$id",
        "/_app/supplier/detail/$id",
        "/_app/user/detail/$id"
      ]
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/logout": {
      "filePath": "logout.tsx"
    },
    "/password-reset_": {
      "filePath": "password-reset_.tsx"
    },
    "/set-new-password": {
      "filePath": "set-new-password.tsx"
    },
    "/_app/_lubes": {
      "filePath": "_app._lubes.tsx",
      "parent": "/_app",
      "children": [
        "/_app/_lubes/compare",
        "/_app/_lubes/customers",
        "/_app/_lubes/dashboard",
        "/_app/_lubes/demand",
        "/_app/_lubes/key-ports",
        "/_app/_lubes/offers",
        "/_app/_lubes/orders",
        "/_app/_lubes/products",
        "/_app/_lubes/statistics",
        "/_app/_lubes/suppliers",
        "/_app/_lubes/agents/$id",
        "/_app/_lubes/offer/$id",
        "/_app/_lubes/order/$id",
        "/_app/_lubes/orders_/new",
        "/_app/_lubes/vessel/$id",
        "/_app/_lubes/agents/",
        "/_app/_lubes/offer/$id_/edit",
        "/_app/_lubes/offer/$id_/quote",
        "/_app/_lubes/order_/edit/$id",
        "/_app/_lubes/orders_/draft/$id"
      ]
    },
    "/_app/assignments": {
      "filePath": "_app.assignments.tsx",
      "parent": "/_app"
    },
    "/_app/customer-groups": {
      "filePath": "_app.customer-groups.tsx",
      "parent": "/_app"
    },
    "/_app/fuel": {
      "filePath": "_app.fuel.tsx",
      "parent": "/_app",
      "children": [
        "/_app/fuel/assignments",
        "/_app/fuel/contracts",
        "/_app/fuel/create",
        "/_app/fuel/dashboard",
        "/_app/fuel/global-prices",
        "/_app/fuel/key-ports",
        "/_app/fuel/offers",
        "/_app/fuel/orders",
        "/_app/fuel/statistics",
        "/_app/fuel/vessels",
        "/_app/fuel/agents/$id",
        "/_app/fuel/offer/$id",
        "/_app/fuel/order/$id",
        "/_app/fuel/planning/bunker-plan",
        "/_app/fuel/planning/demand",
        "/_app/fuel/vessel/$id",
        "/_app/fuel/agents/",
        "/_app/fuel/offer/$id_/edit",
        "/_app/fuel/offer/$id_/quote",
        "/_app/fuel/order/$id_/edit",
        "/_app/fuel/planning/solutions/$vesselId/$caseNumber/$solutionNumber"
      ]
    },
    "/_app/integrations": {
      "filePath": "_app.integrations.tsx",
      "parent": "/_app"
    },
    "/_app/ports": {
      "filePath": "_app.ports.tsx",
      "parent": "/_app"
    },
    "/_app/search": {
      "filePath": "_app.search.tsx",
      "parent": "/_app"
    },
    "/_app/supplier-groups": {
      "filePath": "_app.supplier-groups.tsx",
      "parent": "/_app"
    },
    "/_app/users": {
      "filePath": "_app.users.tsx",
      "parent": "/_app"
    },
    "/_app/vessels": {
      "filePath": "_app.vessels.tsx",
      "parent": "/_app"
    },
    "/limited-quotation/$anonymousQuotationId": {
      "filePath": "limited-quotation.$anonymousQuotationId.tsx"
    },
    "/_app/_lubes/compare": {
      "filePath": "_app._lubes.compare.tsx",
      "parent": "/_app/_lubes"
    },
    "/_app/_lubes/customers": {
      "filePath": "_app._lubes.customers.tsx",
      "parent": "/_app/_lubes"
    },
    "/_app/_lubes/dashboard": {
      "filePath": "_app._lubes.dashboard.tsx",
      "parent": "/_app/_lubes"
    },
    "/_app/_lubes/demand": {
      "filePath": "_app._lubes.demand.tsx",
      "parent": "/_app/_lubes"
    },
    "/_app/_lubes/key-ports": {
      "filePath": "_app._lubes.key-ports.tsx",
      "parent": "/_app/_lubes"
    },
    "/_app/_lubes/offers": {
      "filePath": "_app._lubes.offers.tsx",
      "parent": "/_app/_lubes"
    },
    "/_app/_lubes/orders": {
      "filePath": "_app._lubes.orders.tsx",
      "parent": "/_app/_lubes"
    },
    "/_app/_lubes/products": {
      "filePath": "_app._lubes.products.tsx",
      "parent": "/_app/_lubes"
    },
    "/_app/_lubes/statistics": {
      "filePath": "_app._lubes.statistics.tsx",
      "parent": "/_app/_lubes"
    },
    "/_app/_lubes/suppliers": {
      "filePath": "_app._lubes.suppliers.tsx",
      "parent": "/_app/_lubes"
    },
    "/_app/customer-group/$id": {
      "filePath": "_app.customer-group.$id.tsx",
      "parent": "/_app"
    },
    "/_app/fuel/assignments": {
      "filePath": "_app.fuel.assignments.tsx",
      "parent": "/_app/fuel"
    },
    "/_app/fuel/contracts": {
      "filePath": "_app.fuel.contracts.tsx",
      "parent": "/_app/fuel"
    },
    "/_app/fuel/create": {
      "filePath": "_app.fuel.create.tsx",
      "parent": "/_app/fuel"
    },
    "/_app/fuel/dashboard": {
      "filePath": "_app.fuel.dashboard.tsx",
      "parent": "/_app/fuel"
    },
    "/_app/fuel/global-prices": {
      "filePath": "_app.fuel.global-prices.tsx",
      "parent": "/_app/fuel"
    },
    "/_app/fuel/key-ports": {
      "filePath": "_app.fuel.key-ports.tsx",
      "parent": "/_app/fuel"
    },
    "/_app/fuel/offers": {
      "filePath": "_app.fuel.offers.tsx",
      "parent": "/_app/fuel"
    },
    "/_app/fuel/orders": {
      "filePath": "_app.fuel.orders.tsx",
      "parent": "/_app/fuel"
    },
    "/_app/fuel/statistics": {
      "filePath": "_app.fuel.statistics.tsx",
      "parent": "/_app/fuel"
    },
    "/_app/fuel/vessels": {
      "filePath": "_app.fuel.vessels.tsx",
      "parent": "/_app/fuel"
    },
    "/_app/supplier-group/$id": {
      "filePath": "_app.supplier-group.$id.tsx",
      "parent": "/_app"
    },
    "/offer/$offerId/approval-request": {
      "filePath": "offer.$offerId.approval-request.tsx"
    },
    "/onboard/$userId/$token": {
      "filePath": "onboard.$userId.$token.tsx"
    },
    "/_app/_lubes/agents/$id": {
      "filePath": "_app._lubes.agents.$id.tsx",
      "parent": "/_app/_lubes"
    },
    "/_app/_lubes/offer/$id": {
      "filePath": "_app._lubes.offer.$id.tsx",
      "parent": "/_app/_lubes"
    },
    "/_app/_lubes/order/$id": {
      "filePath": "_app._lubes.order.$id.tsx",
      "parent": "/_app/_lubes"
    },
    "/_app/_lubes/orders_/new": {
      "filePath": "_app._lubes.orders_.new.tsx",
      "parent": "/_app/_lubes"
    },
    "/_app/_lubes/vessel/$id": {
      "filePath": "_app._lubes.vessel.$id.tsx",
      "parent": "/_app/_lubes"
    },
    "/_app/customer/detail/$id": {
      "filePath": "_app.customer.detail.$id.tsx",
      "parent": "/_app"
    },
    "/_app/fuel/agents/$id": {
      "filePath": "_app.fuel.agents.$id.tsx",
      "parent": "/_app/fuel"
    },
    "/_app/fuel/offer/$id": {
      "filePath": "_app.fuel.offer.$id.tsx",
      "parent": "/_app/fuel"
    },
    "/_app/fuel/order/$id": {
      "filePath": "_app.fuel.order.$id.tsx",
      "parent": "/_app/fuel"
    },
    "/_app/fuel/planning/bunker-plan": {
      "filePath": "_app.fuel.planning.bunker-plan.tsx",
      "parent": "/_app/fuel"
    },
    "/_app/fuel/planning/demand": {
      "filePath": "_app.fuel.planning.demand.tsx",
      "parent": "/_app/fuel"
    },
    "/_app/fuel/vessel/$id": {
      "filePath": "_app.fuel.vessel.$id.tsx",
      "parent": "/_app/fuel"
    },
    "/_app/port/detail/$id": {
      "filePath": "_app.port.detail.$id.tsx",
      "parent": "/_app"
    },
    "/_app/supplier/detail/$id": {
      "filePath": "_app.supplier.detail.$id.tsx",
      "parent": "/_app"
    },
    "/_app/user/detail/$id": {
      "filePath": "_app.user.detail.$id.tsx",
      "parent": "/_app"
    },
    "/_app/_lubes/agents/": {
      "filePath": "_app._lubes.agents.index.tsx",
      "parent": "/_app/_lubes"
    },
    "/_app/fuel/agents/": {
      "filePath": "_app.fuel.agents.index.tsx",
      "parent": "/_app/fuel"
    },
    "/_app/_lubes/offer/$id_/edit": {
      "filePath": "_app._lubes.offer.$id_.edit.tsx",
      "parent": "/_app/_lubes"
    },
    "/_app/_lubes/offer/$id_/quote": {
      "filePath": "_app._lubes.offer.$id_.quote.tsx",
      "parent": "/_app/_lubes"
    },
    "/_app/_lubes/order_/edit/$id": {
      "filePath": "_app._lubes.order_.edit.$id.tsx",
      "parent": "/_app/_lubes"
    },
    "/_app/_lubes/orders_/draft/$id": {
      "filePath": "_app._lubes.orders_.draft.$id.tsx",
      "parent": "/_app/_lubes"
    },
    "/_app/fuel/offer/$id_/edit": {
      "filePath": "_app.fuel.offer.$id_.edit.tsx",
      "parent": "/_app/fuel"
    },
    "/_app/fuel/offer/$id_/quote": {
      "filePath": "_app.fuel.offer.$id_.quote.tsx",
      "parent": "/_app/fuel"
    },
    "/_app/fuel/order/$id_/edit": {
      "filePath": "_app.fuel.order.$id_.edit.tsx",
      "parent": "/_app/fuel"
    },
    "/_app/fuel/planning/solutions/$vesselId/$caseNumber/$solutionNumber": {
      "filePath": "_app.fuel.planning.solutions.$vesselId.$caseNumber.$solutionNumber.tsx",
      "parent": "/_app/fuel"
    }
  }
}
ROUTE_MANIFEST_END */
